import { createContext } from 'react';

export const CotizationPreviewContext = createContext({});
